import React from 'react'
import { Link } from 'react-router-dom'
import classes from './Footer.module.css'

const Footer = () => {
  return (
    <div  className={classes.container}>
      Copyright © {new Date().getFullYear()} <Link to='/tnc'><span className={classes.text}>Kids Videos</span></Link>
    </div>
  )
}

export default Footer
